import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Navbar from '../components/Navbar/Navbar';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import logo from "../components/assets/im_logo.png";
import Loader from "@mui/material/CircularProgress";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";

const ResetPassword = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false)
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false)
  const { token } = useParams();
  const navigate = useNavigate()
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const API_URL = process.env.REACT_APP_API_URL;

  const { mutate, isPending: isSubmitting} = useMutation({
    mutationFn: async ({ newPassword }) => {
      const res = await fetch(`${API_URL}/auth/reset-password/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ newPassword }),
      });

      const data = await res.json();
      console.log(data);
      
      if (!res.ok) {
        throw new Error(data.error || 'Something went wrong');
      }
      return data;
    },
    onSuccess: (data) => {
      toast.success(data.message || 'Password reset successful');
      navigate("/login")
      setNewPassword('');
      setConfirmPassword('');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to reset password');
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate password fields
    if (!newPassword || !confirmPassword) {
      toast.error('Please fill in both fields');
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    mutate({ newPassword });
  };

  return (
    <>
      <Header />
      <Navbar />
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-4 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img alt="Your Company" src={logo} className="mx-auto h-24 w-auto" />
          <h2 className="mt-10 text-center text-2xl font-medium tracking-tight text-gray-900">
            Reset your password
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-900"
              >
                New Password
              </label>
              <div className="mt-2 relative">
                <input
                  id="password"
                  name="password"
                  type={isPasswordVisible ? "text" : "password"}
                  placeholder="Enter your new password"
                  required
                  autoComplete="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:outline-indigo-600 sm:text-sm"
                />
                {isPasswordVisible ? <FaRegEye onClick={()=>{setPasswordVisible(!isPasswordVisible)}} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-800 cursor-pointer" size={20} /> : <FaRegEyeSlash onClick={()=>{setPasswordVisible(!isPasswordVisible)}} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-800 cursor-pointer" size={20} />}
              </div>
            </div>

            <div>
              <label
                htmlFor="confirmPassword"
                className="block text-sm font-medium text-gray-900"
              >
                Confirm Password
              </label>
              <div className="mt-2 relative">
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type={isConfirmPasswordVisible ? "text" : "password"}
                  placeholder="Confirm your new password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:outline-indigo-600 sm:text-sm"
                />
                {isConfirmPasswordVisible ? <FaRegEye onClick={()=>{setConfirmPasswordVisible(!isConfirmPasswordVisible)}} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-800 cursor-pointer" size={20} /> : <FaRegEyeSlash onClick={()=>{setConfirmPasswordVisible(!isConfirmPasswordVisible)}} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-800 cursor-pointer" size={20} />}
              </div>
            </div>

            <div className="mt-6">
              <button
                type="submit"
                disabled={isSubmitting}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {isSubmitting ?  <Loader sx={() => ({ color: "#ffffff" })} size={24}/> : "Reset Password"}
              </button>
            </div>
          </form>

          <p className="mt-10 text-center text-sm text-gray-500">
            Remembered your password?{' '}
            <a href="/login" className="font-semibold text-indigo-600 hover:text-indigo-500">
              Login here
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
